import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./afla-module.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./afla-module.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { AflaModuleStatus } from "../shared/module-status.model";
import { Router } from "@angular/router";
import { AppControllerService } from "../../../app-controller.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
let AflaModuleComponent = class AflaModuleComponent {
    router;
    appControllerService;
    userInformationService;
    getModule;
    set module(model) {
        this.getModule = model;
    }
    get module() {
        return this.getModule;
    }
    searchedName;
    set overdueCount(overdueCount) {
        this.updateOverdueCounts(overdueCount);
    }
    set fiveDayToGo(fiveDayToGo) {
        this.updateFiveDayToGo(fiveDayToGo);
    }
    set statusCount(statusCount) {
        this.updateStatusCount(statusCount);
    }
    set openedApplicationsCounts(openedCount) {
        this.updateOpenedApplicationCounts(openedCount);
    }
    set closedApplicationsCounts(closedCount) {
        this.updateClosedApplicationCounts(closedCount);
    }
    set totalApplicationsCounts(totalCount) {
        this.updateTotalApplicationCounts(totalCount);
    }
    closedApplicationsCountsMap = new Map();
    openedApplicationsCountsMap = new Map();
    totalApplicationsCountsMap = new Map();
    moduleStatuses;
    phases;
    constructor(router, appControllerService, userInformationService) {
        this.router = router;
        this.appControllerService = appControllerService;
        this.userInformationService = userInformationService;
    }
    ngOnInit() {
    }
    trackModuleStatus(index, item) {
        return item;
    }
    openApplications() {
        this.appControllerService.setSelectedModule(this.module.id);
        this.router.navigate([
            AppRoutingConstants.ROUTE_SEPERATOR +
                this.appControllerService.selectedModuleID +
                AppRoutingConstants.ROUTE_SEPERATOR +
                ApplicationsRoutingConstants.APPLICATIONS_ROUTE,
        ]);
    }
    updateStatusCount(statusCount) {
        statusCount?.forEach((elm) => {
            if (this.phases)
                this.phases.push({ name: elm.status, value: elm.count });
            else if (!this.phases && elm.count) {
                this.phases = [{ name: elm.status, value: elm.count }];
            }
        });
    }
    updateFiveDayToGo(fiveDayToGo) {
        if (this.moduleStatuses) {
            this.moduleStatuses.push({
                status: AflaModuleStatus.Remaining,
                value: fiveDayToGo,
            });
        }
        else if (!this.phases && fiveDayToGo) {
            this.moduleStatuses = [
                {
                    status: AflaModuleStatus.Remaining,
                    value: fiveDayToGo,
                },
            ];
        }
    }
    updateOverdueCounts(overdueCount) {
        if (this.moduleStatuses) {
            this.moduleStatuses.push({
                status: AflaModuleStatus.Overdue,
                value: overdueCount,
            });
        }
        else if (!this.phases && overdueCount) {
            this.moduleStatuses = [
                {
                    status: AflaModuleStatus.Overdue,
                    value: overdueCount,
                },
            ];
        }
    }
    updateTotalApplicationCounts(totalCount) {
        if (this.moduleStatuses) {
            this.moduleStatuses.push({
                status: AflaModuleStatus.TotalApplicationCount,
                value: totalCount,
            });
        }
        else if (!this.phases && totalCount) {
            this.moduleStatuses = [
                {
                    status: AflaModuleStatus.TotalApplicationCount,
                    value: totalCount,
                },
            ];
        }
    }
    updateOpenedApplicationCounts(openedCount) {
        if (this.moduleStatuses) {
            this.moduleStatuses.push({
                status: AflaModuleStatus.OpenApplicationCount,
                value: openedCount,
            });
        }
        else if (!this.phases && openedCount) {
            this.moduleStatuses = [
                {
                    status: AflaModuleStatus.OpenApplicationCount,
                    value: openedCount,
                },
            ];
        }
    }
    updateClosedApplicationCounts(closedCount) {
        if (this.moduleStatuses) {
            this.moduleStatuses.push({
                status: AflaModuleStatus.ClosedApplicationCount,
                value: closedCount,
            });
        }
        else if (!this.phases && closedCount) {
            this.moduleStatuses = [
                {
                    status: AflaModuleStatus.ClosedApplicationCount,
                    value: closedCount,
                },
            ];
        }
    }
    static ctorParameters = () => [
        { type: Router },
        { type: AppControllerService },
        { type: UserInformationService }
    ];
    static propDecorators = {
        module: [{ type: Input }],
        searchedName: [{ type: Input }],
        overdueCount: [{ type: Input }],
        fiveDayToGo: [{ type: Input }],
        statusCount: [{ type: Input }],
        openedApplicationsCounts: [{ type: Input }],
        closedApplicationsCounts: [{ type: Input }],
        totalApplicationsCounts: [{ type: Input }]
    };
};
AflaModuleComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-afla-module",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AflaModuleComponent);
export { AflaModuleComponent };
